var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBuyersShopping(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 23624",
    transform: "translate(0 -384)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 5440",
    width: 75,
    height: 75,
    rx: 15,
    transform: "translate(0 384)",
    style: {
      fill: "#efefef"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Shopping bag"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "shopping-cart (3)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 19697"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 19696"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17019",
    d: "M296.086 338.862a3.734 3.734 0 1 0 3.734 3.734 3.778 3.778 0 0 0-3.734-3.734z",
    transform: "translate(-250.342 90.41)",
    style: {
      fill: "#7c7c7c"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 19699"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 19698"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17020",
    d: "M30.8 15.876c-.072 0-.18-.036-.287-.036H7.9l-.359-2.405a3.215 3.215 0 0 0-3.2-2.764H1.436a1.436 1.436 0 1 0 0 2.872h2.908a.382.382 0 0 1 .359.323l2.226 15.15a3.936 3.936 0 0 0 3.877 3.339h14.935a3.99 3.99 0 0 0 3.877-3.159l2.334-11.668a1.419 1.419 0 0 0-1.152-1.652z",
    transform: "translate(21.511 395.59)",
    style: {
      fill: "#7c7c7c"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 19701"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 19700"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17021",
    d: "M118.361 342.416a3.712 3.712 0 0 0-3.7-3.554 3.755 3.755 0 0 0-3.59 3.877 3.68 3.68 0 0 0 3.662 3.554h.072a3.726 3.726 0 0 0 3.556-3.877z",
    transform: "translate(-81.771 90.41)",
    style: {
      fill: "#7c7c7c"
    }
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuyersShopping);
export default __webpack_public_path__ + "static/media/buyers_shopping.956c154cc302d657323f360f92a0c368.svg";
export { ForwardRef as ReactComponent };